import classes from './ProductTile.module.css';

const ProductTileSkeleton = () => {
    return (
        <div className={classes.root}>
            <div className={classes.skeleton}></div>
        </div>
    );
}

export default ProductTileSkeleton;